import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import axios, { AxiosRequestConfig } from 'axios';

import { MAXIMUM_CAMPAIGN_COUNT_UNDER_ACCOUNT } from './utils';

interface IFetchSingleCampaignUrlProps {
  accountId: string;
  customerId: string;
  campaignId: string;
}

export interface IFetchSingleCampaignProps extends IFetchSingleCampaignUrlProps {
  ccToken: string;
}

export function fetchSingleCampaignUrl({
  customerId,
  accountId,
  campaignId,
}: IFetchSingleCampaignUrlProps) {
  const params = {
    $filter: `Id eq ${campaignId}`,
    $top: MAXIMUM_CAMPAIGN_COUNT_UNDER_ACCOUNT,
    $skip: '0',
  };
  const queryString = new URLSearchParams(params);

  return `${getOdataRootUrl({ accountId, customerId })}/Campaigns?${queryString}`;
}

export function fetchSingleCampaignData({
  accountId,
  customerId,
  campaignId,
  ccToken,
}: IFetchSingleCampaignProps) {
  const url = fetchSingleCampaignUrl({
    accountId,
    customerId,
    campaignId,
  });

  return axios.get(url, {
    headers: {
      Authorization: ccToken,
    },
  } as AxiosRequestConfig);
}
